import angular from "angular";
import Vue from "vue";
import "ngVue";

import dcModalNgvue from "./Modal-Ngvue.vue";

export default angular
  .module("directives.modalNgvue", [])
  .directive("dcModalNgvue", [
    "createVueComponent",
    function (createVueComponent) {
      return createVueComponent(Vue.component("DcModalNgvue", dcModalNgvue));
    },
  ]);
